module.exports = __webpack_public_path__ + "img/fast-delivery.a2abd2a.svg";